import { Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

interface Solution {
    title: string,
    text: string,
    textList: string[],
    img: string,
    imgMobile: string,
    link: string,
}

@Component({
  selector: 'app-solutions-card',
  imports: [FontAwesomeModule],
  templateUrl: './solutions-card.html',
  styleUrl: './solutions-card.scss',
})
export class SolutionsCard {

  check = faCircleCheck

  solution = input<Solution>({
    title: 'Titulo',
    text: 'lorem ipsum',
    textList: [
              'Aaaaa',
              'BBbb',
              'CCCcccc',

    ],
    img: 'assets/solution-cards/solution-card-1-mobile.jpg',
    imgMobile: 'assets/solution-cards/solution-card-1-mobile.jpg',
    link: 'https://wolfavionic.com'
  })

}
